jQuery(document).ready(function ($) {
    ({
        init: function () {
            this.toggle_collection_filter();
            // this.collection_slider();
        },
        toggle_collection_filter: function () {
            $('.current-collection').click(function () {
                $(this).toggleClass('active');
                if ($(window).width() > 767) {
                    $('.bc-sf-filter-option-block-collections .bc-sf-filter-block-content').stop(!0, !0).slideToggle();
                } else {
                    $('#bc-sf-filter-tree').stop(!0, !0).slideToggle();
                }
            })
        },
        collection_slider: function () {
            var $lightSlider = $('.collection-list-box .card-list');
            $lightSlider.removeClass('row');
            var slider = $lightSlider.lightSlider({
                item: 5,
                loop: true,
                slideMove: 2,
                easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                speed: 1200,
                pager: false,
                auto: false,
                pause: 5200,
                slideMargin: 0,
                responsive: [{
                        breakpoint: 992,
                        settings: {
                            item: 4,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            item: 3,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            item: 2,
                        }
                    }
                ]
            });
        },
    }).init()
});